// C:\Helpdesk\frontend\src\layout\MainLayout\Footer\index.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../layout.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} YPS Helpdesk System. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;